// IframeConnect iframe通信(只能限定源通信不能指定具体的某个网页通信)
// https://webapp.xitohere.com
// https://lisheng.xitohere.com
// https://contents.expo-museum.com
// https://panvr.xitohere.com/e/edit.html

/*
  使用流程：
    子页面初始化之后，会立即发送INIT_END事件给父页面，表示加载完毕可以进行通信传输数据
    ......
*/
class IframeConnect {
	static encryptedAndDecrypted(text = '', type = 'decrypted', number) {
		if (typeof text === 'string' && text) {
			try {
				// 文字加密
				if (type === 'encrypted') {
					number = (typeof number === 'number' && 0 <= number && number < 10) ? number : Math.floor(Math.random() * 10);
					return Array.from(btoa(encodeURIComponent(text))).map(char => String.fromCharCode(char.charCodeAt(0) + number)).join('') + String(number);
				}
				// 文字解密
				if (type === 'decrypted') {
					number = (typeof number === 'number' && 0 <= number && number < 10) ? number : Number(text.substring(text.length - 1));
					return decodeURIComponent(atob(Array.from(text.substring(0, text.length - 1)).map(char => String.fromCharCode(char.charCodeAt(0) - number)).join('')));
				}
			} catch(err) {}
		}
		return text;
	}
	
	constructor() {
		this.bindReceiveMessage = this.receiveMessage.bind(this);
	    this.destroy();
	}
	
	init(config = {}, onEvent = null) {
		/*
			config: {
				role: parent父页面 | child子页面
				debug: false | true
				target: parent => iframeDOM | child => window
				whiteList: '*' | 'http:xxx.com' | []
			}
		*/
		this.destroy();
	    const { role, debug, target, whiteList } = config;
		if (['parent', 'child'].indexOf(role) > -1) {
			let originRoster = [];
			let targetOrigin = '';
			let targetWindow = null;
			// 设置允许通信的白名单
			if (typeof whiteList === 'string') {
				originRoster = [whiteList].map(this.getOriginByUrl);
			}
			if (Array.isArray(whiteList)) {
				originRoster = whiteList.map(this.getOriginByUrl);
			}
			// 根据target设置targetOrigin和targetWindow
			if (role === 'child') {
				// 如果是子页面的话，target就应该是当前的window
				targetOrigin = this.getParentOrigin(target);
				targetWindow = target.parent;
			}
			if (role === 'parent') {
				// 如果是父页面的话，target就应该是当前的iframe的DOM元素
				targetOrigin = this.getChildOrigin(target);
				targetWindow = target.contentWindow;
			}
			// 如果通信源是当前页面的源就不允许通信
			if (targetOrigin === window.location.origin) {
				targetOrigin = '';
				targetWindow = null;
			}
			// 判断能否通信
			if (originRoster.length && targetOrigin && targetWindow) {
				const index = originRoster.findIndex(origin => origin === targetOrigin);
				if (originRoster[0] === '*' || index > -1) {
					/****** 允许通信 ******/
					// 设置使用角色
					this.role = role;
					// 设置是否要开启调试打印模式
					this.debug = Boolean(debug);
					// 设置通信白名单
					this.originRoster = originRoster;
					// 设置当前通信源
					this.targetOrigin = targetOrigin;
					// 设置当前对象的window
					this.targetWindow = targetWindow;
					// 设置接收信息的回调函数
					this.onEvent = typeof onEvent === 'function' ? onEvent : null;
					// 监听拦截通信
					window.addEventListener('message', this.bindReceiveMessage);
					return true;
				}
			}
		}
		console.error('参数错误，无法使用通信功能', config, onEvent);
		return false;
	}
	destroy() {
		this.role = '';				// 使用角色 parent child
		this.debug = false;			// 开启调试打印模式
		this.onEvent = null;		// 接收消息时的回调函数
		this.originRoster = [];		// 允许通信的网页源名单(要等于或包含targetOrigin，对应iframe的src，例如: 'http://192.168.0.101:8080,http://192.168.0.101:8081/edit.html')
		this.targetOrigin = '';		// 当前与之通信的网页源
		this.targetWindow = null;	// 当前与之通信的网页window对象
		window.removeEventListener('message', this.bindReceiveMessage);
	}
	sendMessage(type = '', data = null) {
		if (this.role && this.targetOrigin && this.targetWindow && this.targetWindow['postMessage']) {
			const time = Date.now();
			const message = {
				type,
				data,
				time
			};
			if ((this.role === 'child') && this.debug) console.log('%c 子页面发送消息给父页面', 'color: green', message) // JSON.parse(JSON.stringify(message))
			if ((this.role === 'parent') && this.debug) console.log('%c 父页面发送消息给子页面', 'color: red', message)
			this.targetWindow['postMessage'](message, this.targetOrigin);
		}
	}
	receiveMessage(event = {}) {
		if (event.origin && this.targetOrigin && event.origin === this.targetOrigin) {
			if ((this.role === 'child') && this.debug) console.log('%c 子页面接收消息', 'color: green', event.data)
			if ((this.role === 'parent') && this.debug) console.log('%c 父页面接收消息', 'color: red', event.data)
			this.onEvent && this.onEvent(event.data, this.sendMessage.bind(this));
		}
	}
	
	getOriginByUrl(url = '') {
		try {
			return new URL(url).origin;
		} catch(err) {
			return url === '*' ? url : '';
		}
	}
	getChildOrigin(iframeDOM) {
		// 当前是父页面获取子页面的origin
		const url = iframeDOM.src;
		return this.getOriginByUrl(url);
	}
	getParentOrigin(curWindow) {
		// 当前是子页面获取父页面的origin
		let url = '';
		try {
			url = curWindow.parent.location.href;
		} catch(err) {
			url = curWindow.document.referrer;
		}
		return this.getOriginByUrl(url);
	}
}

export default new IframeConnect